import script from "./CalculatedRoutes.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatedRoutes.vue?vue&type=script&setup=true&lang=js"

import "./CalculatedRoutes.vue?vue&type=style&index=0&id=82fb2da0&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82fb2da0"]])

export default __exports__